/*

player has 40 missiles. Should be possible to defeat 50-60 unique targets and defend all buildings at a maximum.
If the player only defends two cities then this can go to 120.

Challenge themes:
- many simultaneous targets. Sufficient ammo but targets must be dealt with quickly.
- attritition. Many slow targets requiring careful use of ammo. Some fast targets to throw player.
- bomber rush.

maximum speed: 0.05

*/

/*
const Impossible = {
  generators: {
    "missile-times": {
      times: [{ time: 0, number: 50, splitSize: 0 }],
      speed: 1
    }
  },
  waveSize: 8
};
*/

const L1 = {
  generators: {
    "missile-times": {
      times: [{ time: 0, number: 11, splitSize: 0 }],
      speed: 0.0175
    }
  },
  waveSize: 4
};

const L2 = {
  generators: {
    "missile-times": {
      times: [
        { time: 0, number: 4, splitSize: 0 },
        { time: 1000, number: 1, splitSize: 1 },
        { time: 1000, number: 3, splitSize: 0 },

        { time: 9000, number: 4, splitSize: 0 },
        { time: 10000, number: 1, splitSize: 1 },
        { time: 10000, number: 3, splitSize: 0 }
      ],
      speed: 0.0225
    }
  },
  waveSize: 8
};

const L3 = {
  generators: {
    "missile-times": {
      times: [
        { time: 0, number: 4, splitSize: 0 },
        { time: 1000, number: 1, splitSize: 1 },
        { time: 1000, number: 3, splitSize: 0 },

        { time: 10000, number: 4, splitSize: 0 },
        { time: 11000, number: 1, splitSize: 1 },
        { time: 11000, number: 3, splitSize: 0 }
      ],
      speed: 0.0325
    },
    "bomber-times": {
      times: [{ time: 4500, number: 1, bombs: 1, splitSize: 1 }],
      bombSpeed: 0.0325,
      speed: 0.1
    }
  },
  duration: 45000,
  waveSize: 8
};

const L4 = {
  generators: {
    "missile-times": {
      times: [
        { time: 0, number: 1, splitSize: 1 },
        { time: 0, number: 3, splitSize: 0 },
        { time: 1000, number: 1, splitSize: 2 },
        { time: 1000, number: 3, splitSize: 0 },

        { time: 11000, number: 1, splitSize: 1 },
        { time: 11000, number: 3, splitSize: 0 },
        { time: 12000, number: 1, splitSize: 2 },
        { time: 12000, number: 3, splitSize: 0 },

        { time: 21000, number: 1, splitSize: 2 },
        { time: 21000, number: 1, splitSize: 0 }
      ],
      speed: 0.04
    },
    "bomber-times": {
      times: [
        { time: 4000, number: 1, bombs: 1, splitSize: 1 },
        { time: 17000, number: 1, bombs: 1, splitSize: 1 }
      ],
      speed: 0.1,
      bombSpeed: 0.04
    }
  },
  duration: 45000,
  waveSize: 8,
  environment: "env-4",
  multiplier: 2
};

const L5 = {
  generators: {
    "missile-times": {
      times: [
        { time: 0, number: 1, splitSize: 1 },
        { time: 0, number: 3, splitSize: 0 },
        { time: 1000, number: 1, splitSize: 2 },
        { time: 1000, number: 3, splitSize: 0 },

        { time: 11000, number: 1, splitSize: 1 },
        { time: 11000, number: 3, splitSize: 0 },
        { time: 12000, number: 1, splitSize: 2 },
        { time: 12000, number: 3, splitSize: 0 },

        { time: 21000, number: 1, splitSize: 2 },
        { time: 21000, number: 1, splitSize: 0 }
      ],
      speed: 0.045
    },
    "bomber-times": {
      times: [{ time: 2000, number: 1, bombs: 2, splitSize: 1 }],
      speed: 0.1,
      bombSpeed: 0.045
    },
    "smart-missile-times": {
      times: [19000]
    }
  },
  duration: 45000,
  waveSize: 8,
  environment: "env-4",
  multiplier: 2
};

const L6 = {
  generators: {
    "missile-times": {
      times: [
        { time: 0, number: 1, splitSize: 1 },
        { time: 0, number: 3, splitSize: 0 },
        { time: 1000, number: 1, splitSize: 2 },
        { time: 1000, number: 3, splitSize: 0 },

        { time: 11000, number: 1, splitSize: 1 },
        { time: 11000, number: 3, splitSize: 0 },
        { time: 12000, number: 1, splitSize: 2 },
        { time: 12000, number: 3, splitSize: 0 },

        { time: 21000, number: 1, splitSize: 2 },
        { time: 21000, number: 2, splitSize: 0 }
      ],
      speed: 0.05
    },
    "bomber-times": {
      times: [{ time: 2000, number: 1, bombs: 2, splitSize: 1 }],
      speed: 0.1,
      bombSpeed: 0.05
    },
    "smart-missile-times": {
      times: [3000, 20000, 21000]
    }
  },
  duration: 45000,
  waveSize: 8,
  environment: "env-4",
  multiplier: 3
};

const L7 = {
  generators: {
    "missile-times": {
      times: [
        { time: 0, number: 2, splitSize: 1 },
        { time: 0, number: 3, splitSize: 0 },
        { time: 1000, number: 2, splitSize: 1 },
        { time: 1000, number: 3, splitSize: 0 },

        { time: 11000, number: 2, splitSize: 2 },
        { time: 11000, number: 3, splitSize: 0 },
        { time: 12000, number: 2, splitSize: 3 },
        { time: 12000, number: 3, splitSize: 0 },

        { time: 21000, number: 1, splitSize: 3 },
        { time: 21000, number: 1, splitSize: 2 },
        { time: 21000, number: 2, splitSize: 0 }
      ],
      speed: 0.05
    },
    "bomber-times": {
      times: [
        { time: 1000, number: 1, bombs: 2, splitSize: 1 },
        { time: 14000, number: 1, bombs: 2, splitSize: 2 }
      ],
      speed: 0.1,
      bombSpeed: 0.05
    },
    "smart-missile-times": {
      times: [14000, 20000]
    }
  },
  duration: 45000,
  waveSize: 10,
  multiplier: 4
};

const L8 = {
  generators: {
    "missile-times": {
      times: [
        { time: 0, number: 1, splitSize: 2 },
        { time: 0, number: 4, splitSize: 0 },
        { time: 1000, number: 1, splitSize: 2 },
        { time: 1000, number: 4, splitSize: 0 },

        { time: 11000, number: 1, splitSize: 2 },
        { time: 11000, number: 4, splitSize: 0 },
        { time: 12000, number: 1, splitSize: 3 },
        { time: 12000, number: 4, splitSize: 0 },

        { time: 21000, number: 1, splitSize: 3 },
        { time: 21000, number: 1, splitSize: 2 },
        { time: 21000, number: 2, splitSize: 0 },

        { time: 28000, number: 5, splitSize: 0 },
        { time: 28000, number: 1, splitSize: 3 }
      ],
      speed: 0.05
    },
    "bomber-times": {
      times: [
        { time: 1000, number: 1, bombs: 2, splitSize: 1 },
        { time: 14000, number: 1, bombs: 2, splitSize: 2 }
      ],
      speed: 0.1,
      bombSpeed: 0.05
    },
    "smart-missile-times": {
      times: [5000, 6000, 25000, 25000, 25500]
    }
  },
  duration: 45000,
  waveSize: 10,
  multiplier: 5
};

const LAttrition = {
  generators: {
    "missile-times": {
      times: [{ time: 0, number: 60, splitSize: 0 }],
      speed: 0.03
    }
  },
  waveSize: 10,
  duration: 120000,
  environment: "env-3",
  multiplier: 3
};

const LAttrition_2 = {
  generators: {
    "missile-times": {
      times: [
        { time: 0, number: 2, splitSize: 3 },
        { time: 0, number: 8, splitSize: 0 },
        { time: 0, number: 2, splitSize: 3 },
        { time: 0, number: 8, splitSize: 0 },
        { time: 0, number: 2, splitSize: 3 },
        { time: 0, number: 8, splitSize: 0 },
        { time: 0, number: 2, splitSize: 3 },
        { time: 0, number: 8, splitSize: 0 },
        { time: 0, number: 2, splitSize: 3 },
        { time: 0, number: 8, splitSize: 0 }
      ],
      speed: 0.04
    }
  },
  waveSize: 10,
  duration: 120000,
  environment: "env-3",
  multiplier: 4
};

const LAttrition_3 = {
  generators: {
    "missile-times": {
      times: [{ time: 0, number: 50, splitSize: 0 }],
      speed: 0.04
    },
    "smart-missile-times": {
      times: [2000, 12000, 22000, 32000]
    }
  },
  waveSize: 10,
  duration: 120000,
  environment: "env-3",
  multiplier: 5
};

const LBomberRush_1 = {
  generators: {
    "bomber-times": {
      times: [
        { time: 1000, number: 1, bombs: 1, splitSize: 2, speed: 0.5 },
        { time: 1000, number: 1, bombs: 1, splitSize: 0, speed: 0.5 },
        { time: 1500, number: 1, bombs: 1, splitSize: 2, speed: 0.5 },
        { time: 1500, number: 1, bombs: 1, splitSize: 0, speed: 0.5 },

        { time: 11000, number: 1, bombs: 1, splitSize: 2, speed: 0.5 },
        { time: 11000, number: 1, bombs: 1, splitSize: 0, speed: 0.5 },
        { time: 11500, number: 1, bombs: 1, splitSize: 2, speed: 0.5 },
        { time: 11500, number: 1, bombs: 1, splitSize: 0, speed: 0.5 },

        { time: 21000, number: 1, bombs: 1, splitSize: 2, speed: 0.5 },
        { time: 21000, number: 1, bombs: 2, splitSize: 0, speed: 0.5 },
        { time: 21500, number: 1, bombs: 1, splitSize: 1, speed: 0.5 },
        { time: 21500, number: 1, bombs: 2, splitSize: 0, speed: 0.5 },
        { time: 22000, number: 2, bombs: 2, splitSize: 0, speed: 0.5 }
      ],
      bombSpeed: 0.04
    },
    "missile-times": {
      times: [
        { time: 0, number: 4, splitSize: 0 },
        { time: 10000, number: 4, splitSize: 0 }
      ],
      speed: 0.05
    }
  },
  waveSize: 4,
  duration: 50000,
  environment: "env-2",
  multiplier: 3
};

const LBomberRush_2 = {
  generators: {
    "bomber-times": {
      times: [
        { time: 1000, number: 2, bombs: 2, splitSize: 0, speed: 0.5 },
        { time: 1500, number: 1, bombs: 2, splitSize: 0, speed: 0.5 },
        { time: 1500, number: 1, bombs: 1, splitSize: 1, speed: 0.5 },
        { time: 1500, number: 1, bombs: 1, splitSize: 2, speed: 0.5 },

        { time: 24000, number: 1, bombs: 2, splitSize: 1, speed: 0.5 },
        { time: 24000, number: 1, bombs: 2, splitSize: 0, speed: 0.5 },
        { time: 24500, number: 2, bombs: 2, splitSize: 0, speed: 0.5 }
      ],
      bombSpeed: 0.04
    },
    "missile-times": {
      times: [
        { time: 6000, number: 2, splitSize: 0 },
        { time: 8000, number: 2, splitSize: 0 },
        { time: 10000, number: 1, splitSize: 1 },
        { time: 12000, number: 2, splitSize: 0 },
        { time: 15000, number: 1, splitSize: 1 },
        { time: 24000, number: 2, splitSize: 0 }
      ],
      speed: 0.05
    },
    "smart-missile-times": {
      times: [9000, 16000]
    }
  },
  waveSize: 4,
  duration: 50000,
  environment: "env-2",
  multiplier: 4
};

const LBomberRush_3 = {
  generators: {
    "bomber-times": {
      times: [
        { time: 1000, number: 1, bombs: 1, splitSize: 2, speed: 0.5 },
        { time: 1000, number: 1, bombs: 1, splitSize: 0, speed: 0.5 },
        { time: 1500, number: 1, bombs: 1, splitSize: 2, speed: 0.5 },
        { time: 1500, number: 1, bombs: 1, splitSize: 0, speed: 0.5 },
        { time: 4000, number: 4, bombs: 6, splitSize: 0, speed: 0.05 },

        { time: 16000, number: 1, bombs: 1, splitSize: 2, speed: 0.5 },
        { time: 16000, number: 1, bombs: 1, splitSize: 0, speed: 0.5 },
        { time: 16500, number: 1, bombs: 1, splitSize: 2, speed: 0.5 },
        { time: 16500, number: 1, bombs: 1, splitSize: 0, speed: 0.5 },
        { time: 19000, number: 4, bombs: 6, splitSize: 0, speed: 0.05 },

        { time: 31000, number: 1, bombs: 1, splitSize: 2, speed: 0.5 },
        { time: 31000, number: 1, bombs: 2, splitSize: 0, speed: 0.5 },
        { time: 31500, number: 1, bombs: 1, splitSize: 1, speed: 0.5 },
        { time: 31500, number: 1, bombs: 2, splitSize: 0, speed: 0.5 },
        { time: 32000, number: 2, bombs: 2, splitSize: 0, speed: 0.5 },
        { time: 34000, number: 4, bombs: 6, splitSize: 0, speed: 0.05 }
      ],
      bombSpeed: 0.04
    },
    "smart-missile-times": {
      times: [9000, 16000]
    }
  },
  waveSize: 4,
  duration: 60000,
  environment: "env-2",
  multiplier: 5
};

const levels = [
  L1,
  L2,
  L3,
  L4,
  L5,
  L6,
  LBomberRush_1,
  LBomberRush_2,
  LBomberRush_3,
  LAttrition,
  LAttrition_2,
  LAttrition_3,
  L7,
  L8,
  L6,
  LBomberRush_1,
  LBomberRush_2,
  LBomberRush_3,
  LAttrition,
  LAttrition_2,
  LAttrition_3,
  L7,
  L8,
  L6,
  LBomberRush_1,
  LBomberRush_2,
  LBomberRush_3,
  LAttrition,
  LAttrition_2,
  LAttrition_3,
  L7,
  L8,
  L6,
  LBomberRush_1,
  LBomberRush_2,
  LBomberRush_3,
  LAttrition,
  LAttrition_2,
  LAttrition_3,
  L7,
  L8,
  L6
];

export default levels;
